import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

// const basePath = `${API_URLS.VEHICLE}/v3/Vehicle`;

const basePath = API_URLS.VEHICLE;
const basePathDrivers = API_URLS.DRIVERS;
const basePathLocations = API_URLS.CUSTOMERS;
const basePathMessage = API_URLS.MESSAGES;

async function find(plate, chassi) {
  try {
    var url = plate
      ? `${basePath}/external/by-plate/${plate}`
      : chassi
      ? `${basePath}/chassiscode/${chassi}`
      : "";

    if (url) {
      let response = await api.get(url);

      let treated = errorHandling.handleResponse(
        response,
        "vehicleService.find"
      );
      if (treated) {
        // Normaliza: sempre retorna array
        return Array.isArray(treated) ? treated : [treated];
      }
      return null;
    } else {
      console.log("Parametros para busca de veículo não fornecidos!");
      return null;
    }
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.find");
    return null;
  }
}

const create = async (payload) => {
  try {
    const response = await api.post(
      `${API_URLS.VEHICLE_V3}/registrations`,
      JSON.stringify(payload)
    );

    if (response) {
      if (response.status >= 200 && response.status < 300) {
        return {
          status: response.status,
          data: response.data,
        };
      }

      const treated = errorHandling.handleResponse(
        response,
        "vehicleService.create"
      );
      if (treated) {
        return treated;
      }
    }

    return null;
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.create");
    return {
      status: 500,
      data: { message: error.message },
    };
  }
};

const update = async (payload, id) => {
  try {
    const response = await api.put(
      `${API_URLS.VEHICLE_V3}/registrations/${id}`,
      JSON.stringify(payload)
    );

    if (response?.response?.data?.errors) {
      return {
        status: response.response.status || 400,
        data: response.response.data.errors,
      };
    }

    return {
      status: response.status || 200,
      data: response.data,
    };
  } catch (error) {
    if (error.response?.data?.errors) {
      return {
        status: error.response.status,
        data: error.response.data.errors,
      };
    }

    return {
      status: 500,
      data: { message: error.message },
    };
  }
};

async function fetchTrackingListPaginated(
  groupId,
  vehicleId,
  pageSize,
  pageNumber
) {
  const payload = {
    vehicleGroupId: groupId || 0,
    vehicleId: vehicleId || 0,
    pageSize: pageSize || 25,
    pageNumber: pageNumber || 1,
  };

  try {
    const queryString = new URLSearchParams(payload).toString();
    const url = `${basePath}/paged?${queryString}`;

    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.fetchTrackingListPaginated"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    return null;
  }
}


async function fetchVehicles(groupId) {
  try {
    const hasGroupId =
      groupId !== undefined &&
      groupId !== null &&
      groupId !== "TODOS" &&
      Number(groupId) !== 0;

    var url = hasGroupId
      ? `${API_URLS.VEHICLE_V3_NEW}/vehicles/groups/vehicles?groupId=${groupId}`
      : `${API_URLS.VEHICLE_V3_NEW}/vehicles/groups/vehicles`;

    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleGroupService.fetchVehicles"
    );

    if (treated) {
      if (!Array.isArray(treated)) return treated;

      return treated.map((item) => ({
        ...item,
        id: item.vehicleId,
        plate: item.licensePlate ?? item.licensePlateFormatted ?? "",
        vehicleGroupId: item.groupId,
      }));
    }
    return null;
  } catch (error) {
    return null;
  }
}

async function fetchVehiclesAliases() {
  try {
    var url = `${basePath}/aliases`;

    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleGroupService.fetchVehicles"
    );

    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    return null;
  }
}

async function updateVehicleAlias(vehicleId, alias) {
  try {
    const url = `${API_URLS.VEHICLE_V3}/registrations/${vehicleId}/alias`;

    const payload = { alias: alias };

    let response = await api.patch(url, payload);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.updateVehicleAlias"
    );

    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    return null;
  }
}

async function removeVehicleAlias(vehicleId) {
  try {
    const url = `${API_URLS.VEHICLE_V3}/registrations/${vehicleId}/alias`;

    let response = await api.delete(url);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.removeVehicleAlias"
    );

    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    return null;
  }
}

async function fetchGroups() {
  try {
    var url = `${API_URLS.VEHICLE_V3}/vehicle-groups`;

    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleGroupService.fetchGroups"
    );

    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    return null;
  }
}

async function fetchGroupsById(groupId) {
  try {
    var url = `${API_URLS.VEHICLE}/group/${groupId}/vehicles`;

    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleGroupService.fetchGroupsById"
    );

    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    return null;
  }
}

async function fetchTrackingLocations(payload) {
  try {
    var url = `${basePath}/${payload.vehicleId}/positions/all`;

    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.fetchTrackingLocations"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    return null;
  }
}

async function fetchTrackVehiclesAll(groupId, vehicleId, pageNumber, pageSize, lastReceived) {
  try {
    const payload = {
      vehicleId: vehicleId || 0,
      vehicleGroupId: groupId || 0,
    };

    if (pageNumber !== undefined) payload.PageNumber = pageNumber;
    if (pageSize !== undefined) payload.PageSize = pageSize;
    if (lastReceived) payload.lastReceived = lastReceived;

    const queryString = new URLSearchParams(payload).toString();
    const url = `${basePath}/all?${queryString}`;
    let response = await api.get(url, {
      headers: {
        accept: "*/*",
      },
    });

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.fetchTrackVehiclesAll"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    return null;
  }
}
// ---------------------------------------------------------------------------
async function fetchTrackVehiclesReports(groupId, vehicleId, pageNumber, pageSize, sinceDate) {
  try {
    const payload = {
      VehicleId: vehicleId ?? 0,
      GroupId: groupId ?? 0,
      PageNumber: pageNumber ?? 0,
      PageSize: pageSize ?? 0,
      LastReceived: sinceDate || "2000-01-01",
    };

    const queryString = new URLSearchParams(payload).toString();
    const url = `${API_URLS.REPORTS}/vehicles?${queryString}`;

    let response = await api.get(url, {
      headers: { accept: "*/*" },
    });

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.fetchTrackVehiclesReports"
    );

    if (!treated) return null;

    const paging   = treated?.paging ?? {};
    const rawItems = Array.isArray(treated?.items) ? treated.items : [];

    // Mapeia cada item para o shape que o restante da aplicacao espera
    const vehiclesUser = rawItems.map((item) => {
      const isSentinelOrEmpty =
        !item.generatedAt || item.generatedAt.startsWith("0001-01-01");
      const parsedDate = isSentinelOrEmpty ? null : new Date(item.generatedAt);
      const generatedAtDate =
        parsedDate && !isNaN(parsedDate.getTime()) ? parsedDate : null;

      return {
        ...item,
        plate           : item.licensePlate ?? item.plate ?? "",
        id              : item.vehicleId,
        userDriverName  : item.userDriverName ?? "",
        speedStatusDesc : item.speedStatusDescription ?? item.speedStatusDesc ?? "",
        color           : item.statusColor ?? item.color ?? "",
        colorTip        : item.statusDescription ?? item.colorTip ?? "",
        generatedAtDate,
      };
    });

    const nextLastReceived = treated.lastReceived || paging.lastReceived || null;

    return {
      ...treated,
      vehiclesUser,
      lastReceived : nextLastReceived,
      totalLines   : paging.totalLines   ?? treated.totalLines  ?? 0,
      totalPages   : paging.totalPages   ?? treated.totalPages  ?? 1,
      pageSize     : paging.pageSize     ?? treated.pageSize    ?? 10,
      pageNumber   : paging.pageNumber   ?? treated.pageNumber  ?? 1,
    };
  } catch (error) {
    return null;
  }
}

async function fetchVehiclePositions(vehicleId, payload) {
  try {
    const queryString = new URLSearchParams(payload).toString();
    const url = `${basePath}/${vehicleId}/positions?${queryString}`;

    let response = await api.get(url, {
      headers: {
        accept: "*/*",
      },
    });

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.fetchVehiclePositions"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    return null;
  }
}

async function fetchVehicleTrackPositions(vehicleId, payload) {
  try {
    const queryString = new URLSearchParams(payload).toString();
    const url = `${basePath}/${vehicleId}/positions/all?${queryString}`;

    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.fetchVehicleTrackPositions"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    return null;
  }
}

async function fetchVehicleCommands(vehicleId) {
  try {
    const url = `${basePath}/${vehicleId}/commands`;

    let response = await api.get(url, {
      headers: {
        accept: "*/*",
      },
    });

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.fetchVehicleCommands"
    );

    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    return null;
  }
}

async function fetchVehicleCommandsHistory(payload) {
  try {
    const queryString = new URLSearchParams(payload).toString();
    const url = `${basePath}/${payload.vehicleId}/messages/commands?${queryString}`;

    let response = await api.get(url, {
      headers: {
        accept: "*/*",
      },
    });

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.fetchVehicleCommands"
    );

    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    return null;
  }
}

async function ChangeVehicleMaintenace(vehicleId, payload) {
  try {
    const url = `${basePath}/${vehicleId}/maintenances`;

    let response = await api.put(url, payload);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.ChangeVehicleMaintenace"
    );

    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    return null;
  }
}

async function DeleteVehicleMaintenace(vehicleId, payload) {
  try {
    const url = `${basePath}/${vehicleId}/maintenances`;

    let response = await api.delete(url, payload);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.DeleteVehicleMaintenace"
    );

    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    return null;
  }
}

async function fetchVehicleInfo(vehicleId) {
  try {
    var payload = {
      vehicleId,
    };
    var url = `${basePath}/${vehicleId}`;

    let response = await api.get(url, payload);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.fetchVehicleInfo"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.fetchVehicleInfo");
    return null;
  }
}

async function sendCommand(payload) {
  try {
    var url = `${basePathMessage}`;

    let response = await api.post(url, payload);

    console.log(response);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.sendCommand"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.sendCommand");
    return null;
  }
}

async function fetchVehicleOperationalIndicator() {
  try {
    const url = `${basePath}/operationalIndicator`;

    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.fetchVehicleOperationalIndicator"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(
      error,
      "vehicleService.fetchVehicleOperationalIndicator"
    );
    return null;
  }
}

async function fetchVehicleOperationalIndicatorDetails() {
  try {
    const url = `${basePath}/detailedOperationalIndicator`;

    const payload = {
      immediate: true,
    };

    let response = await api.post(url, payload);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.fetchVehicleOperationalIndicatorDetails"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(
      error,
      "vehicleService.fetchVehicleOperationalIndicatorDetails"
    );
    return null;
  }
}

async function fetchVehicleMaintenanceIndicator() {
  try {
    const url = `${basePath}/maintenanceIndicator`;

    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.fetchVehicleMaintenanceIndicator"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(
      error,
      "vehicleService.fetchVehicleMaintenanceIndicator"
    );
    return null;
  }
}

async function fetchVehicleMaintenanceIndicatorDetails() {
  try {
    const url = `${basePath}/detailedMaintenanceIndicator`;

    const payload = {
      immediate: true,
    };

    let response = await api.post(url, payload);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.fetchVehicleMaintenanceIndicatorDetails"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(
      error,
      "vehicleService.fetchVehicleMaintenanceIndicatorDetails"
    );
    return null;
  }
}

async function fetchVehicleMessagesIndicator() {
  try {
    const url = `${basePath}/messageNotificationIndicator`;

    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.fetchVehicleMessagesIndicator"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(
      error,
      "vehicleService.fetchVehicleMessagesIndicator"
    );
    return null;
  }
}

async function fetchVehicleMessagesIndicatorDetails() {
  try {
    const url = `${basePath}/detailedMessageNotificationIndicator`;

    const payload = {
      atsF_S: "S",
      atsF_N: "S",
    };

    let response = await api.post(url, payload);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.fetchVehicleMessagesIndicatorDetails"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(
      error,
      "vehicleService.fetchVehicleMessagesIndicatorDetails"
    );
    return null;
  }
}

async function defineReadMessage(id, read) {
  try {
    const url = `${basePath}/updateMessageNotification`;

    const payload = {
      immediate: true,
      notificationId: id,
      read: read,
    };

    let response = await api.post(url, payload);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.defineReadMessage"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.defineReadMessage");
    return null;
  }
}

async function fetchDrivers() {
  try {
    var url = `${basePathDrivers}/drivers`;

    let response = await api.get(url);

    if (response.data) return response.data;
    return null;
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.fetchDrivers");
    return null;
  }
}

async function plateIssues() {
  try {
    var url = `${basePath}/with-plate-issues`;

    let response = await api.get(url);

    if (response.data) return response.data;
    return null;
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.plateIssues");
    return null;
  }
}

async function byPlateCode() {
  try {
    var url = `${basePath}/by-plate-code`;

    let response = await api.get(url);

    if (response.data) return response.data;
    return null;
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.byPlateCode");
    return null;
  }
}

async function byPlateCodeInternal(licensePlate) {
  try {
    var url = `${basePath}/admin/by-plate/${licensePlate}`;

    let response = await api.get(url);

    if (response.data) return response.data;
    return null;
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.byPlateCodeInternal");
    return null;
  }
}

async function simulatePlate(licensePlate, chassis) {
  try {
    if (chassis === "") {
      var url = `${basePath}/simulated-plate?prefix=${licensePlate}`;
    } else {
      // eslint-disable-next-line no-redeclare
      var url = `${basePath}/simulated-plate?prefix=${licensePlate}&chassis=${chassis}`;
    }

    let response = await api.get(url);

    if (response.data) return response.data;
    return null;
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.byPlateCodeInternal");
    return null;
  }
}

async function coordinates() {
  try {
    var url = `${basePathLocations}/locations/coordinates`;

    let response = await api.get(url);

    if (response.data) return response.data;
    return null;
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.byPlateCode");
    return null;
  }
}

async function fetchNearbyVehicles(latitude, longitude) {
  try {
    var url = `${basePath}/nearby?latitude=${latitude}&longitude=${longitude}`;

    let response = await api.get(url);

    if (response.data) return response.data;
    return null;
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.fetchNearbyVehicles");
    return null;
  }
}

async function statusCounts() {
  try {
    var url = `${basePath}/status-counts`;
    let response = await api.get(url);
    if (response.data) return response.data;
    return null;
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.statusCounts");
    return null;
  }
}

async function positionsByStatus(code) {
  try {
    var url = `${basePath}/positions-by-status?positionStatusCode=${code}`;
    let response = await api.get(url);
    if (response.data) return response.data;
    return null;
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.positionsByStatus");
    return null;
  }
}

async function fetchRadars() {
  try {
    const url = `${API_URLS.VEHICLE_RADAR}/radars`;
    const response = await api.get(url);
    const treated = errorHandling.handleResponse(response, "vehicleService.fetchRadars");
    return treated ?? null;
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.fetchRadars");
    return null;
  }
}

async function saveRadar(payload) {
  try {
    const url = `${API_URLS.VEHICLE_RADAR}/radars`;
    const response = await api.post(url, payload);
    const treated = errorHandling.handleResponse(response, "vehicleService.saveRadar");
    return treated ?? null;
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.saveRadar");
    return null;
  }
}

export const vehicleService = {
  find,
  create,
  update,
  fetchTrackingListPaginated,
  fetchVehicles,
  fetchVehiclesAliases,
  updateVehicleAlias,
  removeVehicleAlias,
  fetchTrackingLocations,
  fetchVehiclePositions,
  fetchTrackVehiclesAll,
  fetchTrackVehiclesReports,
  fetchVehicleTrackPositions,
  fetchVehicleCommands,
  fetchVehicleCommandsHistory,
  ChangeVehicleMaintenace,
  DeleteVehicleMaintenace,
  fetchVehicleInfo,
  sendCommand,
  fetchVehicleOperationalIndicator,
  fetchVehicleMaintenanceIndicator,
  fetchVehicleMessagesIndicator,
  fetchVehicleOperationalIndicatorDetails,
  fetchVehicleMaintenanceIndicatorDetails,
  fetchVehicleMessagesIndicatorDetails,
  defineReadMessage,
  fetchDrivers,
  plateIssues,
  byPlateCode,
  coordinates,
  fetchGroups,
  fetchNearbyVehicles,
  byPlateCodeInternal,
  simulatePlate,
  statusCounts,
  fetchGroupsById,
  positionsByStatus,
  fetchRadars,
  saveRadar,
};
